import styled from 'styled-components'

export const Outer = styled.section`
  background-image: linear-gradient(
    135deg,
    #ffffff 0%,
    #f2f2f2 32%,
    #ffffff 100%
  );
  padding: 3.8rem 1.8rem;
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 0;
  overflow: hidden;
  .msg {
    line-height: 20px;
  }

  position: relative;
  .error {
    position: absolute;
    right: 0;
    bottom: 6px;
    padding-right: 2px;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.active1};
  }
  .alternate-errors {
    position: absolute;
    right: 0;
    top: 6px;
    padding-right: 2px;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.active1};
  }
`

export const SubmissionWrapper = styled.div`
  position: absolute;
  background-color: hsla(0, 0%, 0%, 0.5);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 50;
  display: flex;
  justify-content: center;
  align-items: center;
  @media only screen and (max-width: 500px) {
    position: fixed;
  }
  .close {
    position: absolute;
    top: 45px;
    right: 45px;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }

  .msg-background {
    text-align: center;
    background-color: white;
    max-width: 700px;
    max-height: 550px;
    position: relative;
    @media only screen and (max-width: 1100px) {
      max-width: 100%;
      max-height: 100%;
    }
    @media only screen and (max-width: 500px) {
      max-width: 100vw;
      max-height: 100vh;
    }
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2rem;
    p {
      font-size: 1.6rem;
      font-weight: 500;
      margin-bottom: 1.4rem;
    }
    > svg {
      width: 100%;
    }
    .success {
      max-width: 447px;
    }

    .failure {
      max-width: 671px;
    }
  }
`

export const Inner = styled.div`
  background-image: none;
  background-color: white;
  max-width: 1221px;
  display: flex;
  justify-content: center;
  z-index: 10;
  overflow: hidden;
  position: relative;
`

export const Content = styled.div`
  max-width: 1295px;
  width: 100%;
  box-sizing: border-box;
  padding: 4rem 9rem;
  z-index: 20;
  @media only screen and (max-width: 866px) {
    padding: 2rem 5rem;
  }
  @media only screen and (max-width: 500px) {
    padding: 2rem 2.2rem;
  }
`

export const TextWrapper = styled.div`
  > h1 {
    max-width: 605px;
    line-height: 1.2;
    margin-bottom: 1.8rem;
    @media only screen and (max-width: 866px) {
      font-size: 40px;
    }
    @media only screen and (max-width: 500px) {
      font-size: 30px;
    }
  }

  > p {
    max-width: 700px;
    font-size: 18px;
    line-height: 1.3;
    letter-spacing: 0.12px;
    @media only screen and (max-width: 500px) {
      font-size: 16px;
    }
  }
  margin: 0 auto;
  margin-bottom: 3.4rem;
  position: relative;
  z-index: 30;
`

export const FormWrapper = styled.div`
  input,
  textarea {
    color: black;
    appearance: none;
    background-color: white;
    border: none;
    border-image: none;
    outline: none;
    font-size: 18px;
  }

  .recaptcha {
    transform: scale(0.85);
    cursor: pointer;
    margin-left: -22px;
    margin-right: 3rem;
  }

  .submit {
    display: flex;
    align-items: center;
    position: relative;
    height: 65px;
    @media only screen and (max-width: 730px) {
      height: auto;
      flex-direction: column;
      align-items: flex-start;
      .recaptcha {
        margin-bottom: 1rem;
        transform: scale(0.8);
        margin-left: -30px;
        margin-right: 0;
      }
    }
  }

  .error-recaptcha {
    position: absolute;
    right: 2px;
    top: -26px;
    padding-top: 6px;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.active1};
  }
`

export const TwoField = styled.div`
  max-width: 884px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 34px;
  @media only screen and (max-width: 600px) {
    display: flex;
    max-width: 100%;
    flex-direction: column;
    margin-bottom: 0;
  }
`

export const FullField = styled.div`
  max-width: 884px;
  width: 100%;
  border-bottom: 2px solid #757575;
  position: relative;
  > input,
  textarea {
    width: 100%;
    max-width: 884px;
    resize: none;
  }
  display: inline-flex;
  margin-bottom: ${({ mBottom }) => mBottom || `34px`};
`

export const HalfField = styled.div`
  max-width: 396px;
  width: 100%;
  display: inline-flex;
  position: relative;
  border-bottom: 2px solid #757575;

  &:first-child {
    margin-right: 20px;
  }
  &:last-child {
    margin-left: 20px;
  }
  > input {
    width: 100%;
    max-width: 396px;
  }
  > label {
    min-width: 90px;
  }
  @media only screen and (max-width: 600px) {
    max-width: 100%;
    margin-bottom: 34px;
    &:first-child {
      margin-right: 0px;
    }
    &:last-child {
      margin-left: 0px;
    
  }

`

export const Label = styled.label`
  display: none;
`

export const RadioButtons = styled.div`
  margin-bottom: 34px;
  position: relative;
  input[type='radio']:after,
  input[type='radio']:checked:after {
    margin-right: 13px !important;
  }
  input[type='radio']:after {
    width: 15px;
    height: 15px;
    border-radius: 15px;
    top: -2px;
    left: -2px;
    position: relative;
    background-color: #d1d3d1;
    content: '';
    display: inline-block;
    visibility: visible;
    border: 2px solid white;
  }

  input[type='radio']:checked:after {
    width: 15px;
    height: 15px;
    border-radius: 15px;
    top: -2px;
    left: -2px;
    position: relative;
    background-color: ${({ theme }) => theme.colors.label};
    content: '';
    display: inline-block;
    visibility: visible;
    border: 2px solid white;
  }
  .radio-button {
    -webkit-appearance: radio;

    margin-right: 13px !important;
    color: ${({ theme }) => theme.colors.label};
  }

  #referral-group {
    color: ${({ theme }) => theme.colors.label};
    opacity: 1;
    font-size: 18px;
    letter-spacing: 0.12px;
    padding-left: 2px;
  }

  .radio-container {
    display: block;
    > label,
    div {
      padding: 10px 0;
    }
  }

  .radio-label {
    font-size: 16px;
    display: block;
    cursor: pointer;
    > input {
      margin-right: 8px;
    }
  }

  #referralOther {
    border-bottom: 2px solid #757575;
    width: 100%;
    ::placeholder {
      font-size: 16px;
    }
  }
`

export const BottomLeftCircle = styled.div`
  width: 258px;
  height: 258px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.active1};
  position: absolute;
  bottom: -74px;
  left: -10px;
  z-index: 0;
`

export const TopRightCircle = styled.div`
  width: 311px;
  height: 311px;
  background-color: ${({ theme }) => theme.colors.formCircle};
  position: absolute;
  border-radius: 50%;
  top: -150px;
  right: -190px;
  z-index: 13;
  @media only screen and (max-width: 866px) {
    top: -200px;
    right: -230px;
    width: 290px;
    height: 290px;
  }
`

export const TopRightLine1 = styled.div`
  width: 471px;
  height: 471px;
  background-color: transparent;
  position: absolute;
  border-radius: 50%;
  top: -240px;
  right: -280px;
  @media only screen and (max-width: 866px) {
    top: -290px;
    right: -330px;
    width: 450px;
    height: 450px;
    opacity: 0.7;
  }
  z-index: 12;
  border: 7px solid ${({ theme }) => theme.colors.formLine1};
  opacity: 0.89;
`

export const TopRightLine2 = styled.div`
  width: 571px;
  height: 571px;
  background-color: transparent;
  position: absolute;
  border-radius: 50%;
  top: -290px;
  right: -330px;
  @media only screen and (max-width: 866px) {
    top: -340px;
    right: -380px;
    width: 550px;
    height: 550px;
    opacity: 0.7;
  }
  z-index: 11;
  border: 4px solid ${({ theme }) => theme.colors.formLine2};
`
